export function formatDate(intlShape, ...[value, formatOptions]) {
  return intlShape.formatDate(value, formatOptions);
}